module.exports = __webpack_public_path__ + "2ee70e961e71872d6d10fca699a99232.pdf";